import React, { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getSettings } from "../../services/settingsServices";

const Footer = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({
    nom_club: "",
    logo_club: "",
    adresse_club: "",
    tel_club: "",
    mail_club: "",
    facebook_club: "",
    instagram_club: "",
  });
  const [mapUrl, setMapUrl] = useState("");

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getSettings();
      if (data.length > 0) {
        setSettings(data[0]);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const encodedAddress = encodeURIComponent(settings.adresse_club);
    const newMapUrl = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;
    setMapUrl(newMapUrl);
  }, [settings.adresse_club]);

  // Fonction pour gérer le défilement vers les ancres
  const handleNavigate = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <div className="footer-wrapper">
      <footer className="bg-gray-800 p-10 text-white border-t-2 flex flex-col lg:flex-row justify-between items-top">
        <div className="map-container flex-1 flex flex-col items-start lg:mb-0">
          <iframe
            title="Location Map"
            src={mapUrl}
            width="100%"
            height="200"
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <p>Adresse : {settings.adresse_club}</p>
          <div className="flex flex-col items-start gap-2">
            {settings.mail_club?.trim() && (
              <div className="flex items-center gap-2">
                <span>Mail :</span>
                <a
                  href={`mailto:${settings.mail_club}`}
                  className="bg-white text-gray-800 px-3 py-1 rounded-full text-sm hover:bg-primary hover:text-white transition"
                  title="Envoyer un email"
                >
                  {settings.mail_club}
                </a>
              </div>
            )}

            {settings.tel_club?.trim() && (
              <div className="flex items-center gap-2 mb-4">
                <span>Téléphone :</span>
                <a
                  href={`tel:${settings.tel_club}`}
                  className="bg-white text-gray-800 px-3 py-1 rounded-full text-sm hover:bg-primary hover:text-white transition"
                  title="Appeler"
                >
                  {settings.tel_club}
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="logo-container flex-1 flex flex-col items-center lg:mb-0">
          <img
            src={settings.logo_club}
            alt={`Logo ${settings.nom_club}`}
            style={{ width: "200px", height: "auto" }}
            className="mb-4 shadow-lg"
          />
          {/* <h2 className="font-titre text-2xl sm:text-3xl font-bold text-white tracking-wide relative inline-block">
            <span className="after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-primary after:mt-1">
              {settings.nom_club}
            </span>
          </h2> */}
        </div>

        <div className="additional-links-container flex-1 flex flex-col items-center lg:mb-0 mt-4">
          <nav className="flex flex-col gap-2 text-center">
            <div className="flex-1 flex flex-col items-center">
              <nav className="flex gap-4 text-2xl">
                {settings.facebook_club?.trim() && (
                  <a
                    href={settings.facebook_club}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-primary"
                  >
                    <FaFacebookF />
                  </a>
                )}
                {settings.instagram_club?.trim() && (
                  <a
                    href={settings.instagram_club}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-primary"
                  >
                    <FaInstagram />
                  </a>
                )}
              </nav>
            </div>
            <a
              href="/reglement-interieur"
              className="link link-hover text-white hover:text-primary"
            >
              Règlement Intérieur
            </a>
            <a
              href="/mentions-legales"
              className="link link-hover text-white hover:text-primary"
            >
              Mentions légales
            </a>
            <a
              href="/politique-confidentialite"
              className="link link-hover text-white hover:text-primary"
            >
              Politique de confidentialité
            </a>
            <a
              href="/conditions-utilisation"
              className="link link-hover text-white hover:text-primary"
            >
              Conditions d’utilisation
            </a>
            <a
              href="/faq"
              className="link link-hover text-white hover:text-primary"
            >
              FAQ
            </a>
            <a
              href="/tutoriel"
              className="link link-hover text-white hover:text-primary"
            >
              Tutoriel
            </a>
          </nav>
        </div>
      </footer>
      <aside className="w-full h-15 bg-black text-white p-2 text-center text-sm">
        <p>
          Copyright © {new Date().getFullYear()} - Tous droits réservés -{" "}
          <a
            href="https://www.monappliclub.com"
            target="_blank"
            rel="noopener noreferrer"
            className="link link-hover text-white hover:text-primary"
          >
            MonAppliClub
          </a>{" "}
          -{" "}
          <a
            href="https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa"
            target="_blank"
            rel="noopener noreferrer"
            className="link link-hover text-white hover:text-primary"
          >
            Laurent VICTORIN
          </a>
        </p>
      </aside>
    </div>
  );
};

export default Footer;
